import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data);
        // Clear the hash from the URL
        window.history.replaceState({}, "", window.location.pathname);
        toast.success(`Welcome, ${data.name.split(" ")[0]}!`);
        nav("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto rounded-full border-4 border-primary/20 border-t-primary animate-spin mb-4" />
        <div className="font-bold text-[#3D405B]">Signing you in…</div>
        <div className="text-sm text-[#7A7D96] mt-1">One moment, we are setting things up.</div>
      </div>
    </div>
  );
}
